<template>
    <!-- 员工职级 -->
    <div class="wrapper">
        <div class="content">
            <div class="search-box min gauge_20">
                <div class="input-item">
                    <span class="label">职级名称</span>
                    <Input v-model="searchParams.rankName" placeholder="请输入" clearable />
                </div>
                <div class="input-item">
                    <span class="label">使用业务员</span>
                    <Input v-model="searchParams.name" placeholder="请输入" clearable />
                </div>
                <!-- <div class="input-item">
                    <span class="label">是否管理职级</span>
                    <RadioGroup v-model="form.type">
                        <Radio label="1" v-if="userInfo.levelCode != '10005'">机构模板</Radio>
                        <Radio label="2">团队模板</Radio>
                    </RadioGroup>
                </div> -->
                <div class="btn-item">
                    <Button type="primary" @click="searchAjax()">查询</Button>
                    <Button v-if="$units.pointAction('org_3_2')" type="warning" @click="$refs.editModal.open({})">新增职级</Button>
                </div>
            </div>
            <div class="table-box">
                <loading :isShow="listLoading" />
                <Table :columns="columns" :data="tableData">
                    <template slot-scope="{ row }" slot="counts">
                        <span class='text-line' @click="$refs.rankUserList.open(row)">{{ row.counts }}</span>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <span class="table-btn" @click="$refs.editModal.open(row)" v-if="$units.pointAction('org_3_2')">编辑</span>
                        <Tooltip content="此职级已分配业务员，不可删除" placement="bottom" v-if="$units.pointAction('org_3_3')&&row.counts != '0'">
                            <span class="table-btn disabled" @click="del(row)">删除</span>
                        </Tooltip>
                        <span class="table-btn" @click="del(row)" v-else-if="$units.pointAction('org_3_3')&&row.counts == '0'">删除</span>
                    </template>
                </Table>
                <div class="pageBox">
                    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
                        style="text-align: center" />
                </div>
            </div>
        </div>
        <!-- 新增职级 -->
        <editModal ref="editModal" @reload="searchAjax()"></editModal>
        <!-- 新增职级 -->
        <rankUserList ref="rankUserList" @reload="searchAjax()"></rankUserList>
    </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import editModal from './editModal';
import rankUserList from './rankUserList';
export default {
    mixins: [pageTool],
    components: {
        editModal,
        rankUserList
    },
    props: {},
    data() {
        return {
            //表单搜索字段
            columns: [
                {
                    title: '职级名称',
                    key: 'name',
                    align: 'center',
                    minWidth: 140,
                    tooltip: true
                },
                {
                    title: '使用业务员',
                    slot: 'counts',
                    align: 'center',
                },

                {
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                    minWidth: 140,
                    render(h, params) {
                        let text = params.row.remark;
                        return h(
                            'Tooltip',
                            {
                                class: 'flex-center',
                                props: { placement: 'bottom-start', transfer: true }
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'txt-ellipsis2'
                                    },
                                    text || '-'
                                ),
                                h('span', { slot: 'content' }, text || '-')
                            ]
                        );
                    }
                },
                {
                    title: '职级等级',
                    key: 'level',
                    align: 'center',
                    width: 120,
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 140,
                    tooltip: true,
                    render(h, params) {
                        const date = params.row.createTime && params.row.createTime.substring(0, 10);
                        return <span>{date}</span>;
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '200'
                }
            ]
        };
    },
    activated(){
      this.getList()
    },
    methods: {
        init() {
            this.initListAjax('/buz/baseRank/read/list');
        },
        setReqParams(params){
            params.apiPermissionCode = 'org_3_0';
        },
        del(row) {
            this.$notice.inquiry('确认删除操作？').then(async () => {
                this.$http({
                    type: 'GET',
                    url: '/buz/baseRank/del',
                    data: {
                        id: row.id
                    },
                    apiPermissionCode:'org_3_3'
                }).then(res => {
                    this.$notice.success('删除成功');
                    this.searchAjax();
                });
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/.text-line {
    text-decoration: underline;
    color: #236DFF;
    cursor: pointer;
}

.wrapper .content {
    .search-box {
        .label {
            font-size: 13px;
            min-width: 70px;
        }

        /deep/ .ivu-input {
            font-size: 13px;
        }

        .btn-item {
            .ivu-btn {
                font-size: 13px;
            }
        }

    }
}
</style>
